import { getValue, compareValue, parseDate } from '../utils/formValue';
export default function initRangedValidator() {

    $.validator.addMethod("ranged",
        function (value, element, params) {
            return isRangeValid(value, element, params);
        })

    $.validator.addMethod("minimum",
        function (value, element, params) {
            return isRangeValid(value, element, params);
        })

    $.validator.addMethod("maximum",
        function (value, element, params) {
            return isRangeValid(value, element, params);
        })

    $.validator.unobtrusive.adapters.add("ranged", ["min", "max", "type", "dateformat", "decimalchar"],
        function (options) {
            options.rules['ranged'] =
                {
                    min: options.params.min,
                    max: options.params.max,
                    type: options.params.type,

                    dateformat: options.params.dateformat,
                    decimalchar: options.params.decimalchar
                };
            options.messages['ranged'] = options.message;
        }
    );

    $.validator.unobtrusive.adapters.add("minimum", ["min", "type", "dateformat", "decimalchar"],
        function (options) {
            options.rules['minimum'] =
                {
                    min: options.params.min,
                    type: options.params.type,

                    dateformat: options.params.dateformat,
                    decimalchar: options.params.decimalchar
                };
            options.messages['minimum'] = options.message;
        }
    );

    $.validator.unobtrusive.adapters.add("maximum", ["max", "type", "dateformat", "decimalchar"],
        function (options) {
            options.rules['maximum'] =
                {
                    max: options.params.max,
                    type: options.params.type,

                    dateformat: options.params.dateformat,
                    decimalchar: options.params.decimalchar
                };
            options.messages['maximum'] = options.message;
        }
    );
}

export function isRangeValid(value, element, params) {
    if ((params["type"] == "System.DateTime" || params["type"] == "System.DateOnly") && parseDate(value) == null) return true; //Continue if not parsed correctly. let date.js handle this

    if (value) {
        var lowerBoundOk = params["min"] ? compareValue(
            value,
            "GreaterThanEqual",
            params["min"],
            params["type"],
            params
        ) : true;

        var upperBoundOk = params["max"] ? compareValue(
            value,
            "LessThanEqual",
            params["max"],
            params["type"],
            params
        ) : true;
        if (!lowerBoundOk || !upperBoundOk) {
            return false;
        }
    }
    return true;
}